import Centered from "./centralComponents/Centered";
import JoinQRMenuTeamImage from "./../images/JoinQRMenuTeamImage.webp"

export default function JoinQRMenuTeam() {
    return (
        <Centered style={{ backgroundColor: '#114a5f', backgroundImage: '' }} maxWidth={false}>
            <img src={JoinQRMenuTeamImage} alt={JoinQRMenuTeamImage} style={{ maxWidth: '100%' }} />
        </Centered>
    );
}